"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _svg = _interopRequireDefault(require("./svg"));

require("./button.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * All other props besides those defined below are passed to <button/> html element.
 * @param {Object} props
 * @param {Node} props.children
 * @param {String} props.className
 * @param {String} props.icon id passed to SVG component
 * @param {Boolean} props.isSubmit Sets button type to submit if true, otherwise type is button
 * @param {String} props.size See proptypes, added as a class on button
 * @param {String} props.type See proptypes, added as a class on button
 * @param {String} props.modifier Modify the appearance of the button. For example, use a light
 *                                outline
 */
var Button = function Button(_ref) {
  var children = _ref.children,
      className = _ref.className,
      icon = _ref.icon,
      isSubmit = _ref.isSubmit,
      size = _ref.size,
      type = _ref.type,
      modifier = _ref.modifier,
      otherProps = _objectWithoutProperties(_ref, ["children", "className", "icon", "isSubmit", "size", "type", "modifier"]);

  var svg = icon ? /*#__PURE__*/_react["default"].createElement(_svg["default"], {
    id: icon,
    className: "buttonIcon"
  }) : null;
  var classes = (0, _classnames["default"])(type, size, modifier, className);
  return (
    /*#__PURE__*/
    // turning this off, eslint thinks its undefined
    // eslint-disable-next-line react/button-has-type
    _react["default"].createElement("button", _extends({
      className: classes
    }, otherProps, {
      type: isSubmit ? 'submit' : 'button'
    }), svg, /*#__PURE__*/_react["default"].createElement("span", null, children))
  );
};

Button.propTypes = {
  type: _propTypes["default"].oneOf(['text', 'secondary', 'default', 'primary', 'clearButton']),
  size: _propTypes["default"].oneOf(['small', 'medium', 'large']),
  modifier: _propTypes["default"].oneOf(['button-outline-light']),
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string,
  icon: _propTypes["default"].string,
  isSubmit: _propTypes["default"].bool
};
Button.defaultProps = {
  type: 'default',
  size: 'medium',
  modifier: null,
  icon: null,
  className: null,
  isSubmit: false
};
var _default = Button;
exports["default"] = _default;